import React from 'react';
import P, { InferProps } from 'prop-types';
import AppMenu from './app-menu';
import FormWithValidationContextProvider from '../../../contexts/formWithValidation';

function AppMenuIndex({ match }: InferProps<typeof AppMenuIndex.propTypes>) {
  const teamAbbrv = match.params.id;

  return (
    <FormWithValidationContextProvider>
      <AppMenu selectedAbbrv={teamAbbrv} />
    </FormWithValidationContextProvider>
  );
}

AppMenuIndex.propTypes = {
  match: P.shape({
    params: P.shape({
      id: P.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default AppMenuIndex;
